import React from 'react';
import { Typography, Paper, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import SettingsIcon from '@mui/icons-material/Settings';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Onboarding = () => {
  const onboardingSteps = [
    {
      icon: <PersonIcon />,
      title: "Create Your Account",
      description: "Sign up and set up your personal profile with AI Talker."
    },
    {
      icon: <BusinessIcon />,
      title: "Company Setup",
      description: "Configure your organization's details and preferences."
    },
    {
      icon: <SettingsIcon />,
      title: "AI Talker Configuration",
      description: "Customize your AI Talker's personality, voice, and knowledge base."
    },
    {
      icon: <PlayArrowIcon />,
      title: "Test Your AI Talker",
      description: "Use the Playground to interact with your AI and refine its responses."
    },
    {
      icon: <CheckCircleIcon />,
      title: "Go Live",
      description: "Deploy your AI Talker and start engaging with your customers."
    }
  ];

  return (
    <Paper elevation={0}>
      <Typography variant="h4" gutterBottom>Onboarding Process</Typography>
      <Typography paragraph>
        Welcome to AI Talker! Our streamlined onboarding process is designed to get you up and running 
        quickly and efficiently. Follow these steps to set up your AI Talker and start leveraging its 
        powerful capabilities for your business.
      </Typography>

      <List>
        {onboardingSteps.map((step, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              {step.icon}
            </ListItemIcon>
            <ListItemText 
              primary={`Step ${index + 1}: ${step.title}`}
              secondary={step.description}
            />
          </ListItem>
        ))}
      </List>

      <Typography variant="h6" style={{ marginTop: '20px' }}>What to Expect:</Typography>
      <Typography paragraph>
        1. The onboarding process typically takes 1-2 hours, depending on the complexity of your setup.
      </Typography>
      <Typography paragraph>
        2. You'll have the opportunity to customize various aspects of your AI Talker to align with your brand and business needs.
      </Typography>
      <Typography paragraph>
        3. Our support team is available throughout the process to assist you with any questions or concerns.
      </Typography>
      <Typography paragraph>
        4. After completing the onboarding, you'll have full access to all AI Talker features and can start engaging with your customers immediately.
      </Typography>

      <Typography paragraph style={{ marginTop: '20px' }}>
        Remember, the key to a successful AI Talker implementation is thorough setup and continuous refinement. 
        Take your time during the onboarding process to ensure your AI is configured optimally for your specific use case. 
        If you need any assistance or have questions at any point during the onboarding, don't hesitate to reach out to our support team.
      </Typography>
    </Paper>
  );
};

export default Onboarding;
